/* import __COLOCATED_TEMPLATE__ from './fly-popover-icon.hbs.js'; */
import Component from '@glimmer/component';
// @ts-ignore: "ember-get-config" is not typed
import config from 'ember-get-config';
var Direction = /*#__PURE__*/function (Direction) {
  Direction["Top"] = "top";
  Direction["Right"] = "right";
  Direction["Bottom"] = "bottom";
  Direction["Left"] = "left";
  return Direction;
}(Direction || {});
export default class FlyPopoverIcon extends Component {
  get iconFill() {
    return this.args.iconFill ?? 'default';
  }
  get iconSize() {
    return this.args.iconSize ?? 'default';
  }
  get direction() {
    return this.args.direction ?? 'bottom';
  }
  get latency() {
    return this.args.latency ?? config?.['fly-components']?.tooltipLatency;
  }
}